import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import useBusinessProfile from '../../hooks/context/useBusinessProfile';

export default function PaymentInfo({ className }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Billing:PaymentInfo' });

  const { getValue } = useBusinessProfile();
  const routingNumber = getValue('bank_routing_number');

  function Field({ label, value }) {
    return (
      <p>
        <b>{label}:</b> {value}
        <Tooltip placement="top" title={t('tooltip', { field: label })} trigger="click">
          <Button icon={<CopyOutlined />} type="text" onClick={() => navigator.clipboard.writeText(value)} />
        </Tooltip>
      </p>
    );
  }

  return (
    <div className={className}>
      <h4>{t('title')}</h4>
      <Field label={t('labels.account_number')} value={getValue('bank_account_number')} />
      {Boolean(routingNumber) && <Field label={t('labels.routing_number')} value={routingNumber} />}

      <h5 className="mt-md">{t('sections.personal_info')}</h5>
      <Field label={t('labels.email')} value={getValue('owner_email')} />
      <Field label={t('labels.full_name')} value={getValue('owner_full_name')} />

      <h5 className="mt-md">{t('sections.address')}</h5>
      <Field label={t('labels.street')} value={getValue('legal_address')} />
      <Field label={t('labels.zip_code')} value={getValue('legal_zip_code')} />
      <Field label={t('labels.city')} value={getValue('legal_city')} />
    </div>
  );
}
